import { makeAutoObservable } from 'mobx';
import { DepositViewType } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/depositFailure/DepositFailure';
import { YaspaUrlResponseType } from 'src/domains/players/webview/components/WithdrawAndDeposit/yaspa/YaspaSegment/YaspaSegment.state';
import { TransactionCallbackType } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/depositFinalView/DepositFinalView';
import { ErrorMessageType } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/errorMessages/DepositErrorMessages.state';

export type MultiDepositStepsType =
    | {
          readonly type: 'set-amount';
      }
    | {
          readonly type: 'select-payment-method';
      }
    | {
          readonly type: 'realex-loader';
          readonly amount: string;
      }
    | {
          readonly type: 'paysafe-loader';
          readonly amount: string;
      }
    | {
          readonly type: 'worldpay-loader';
          readonly amount: string;
          readonly paymentMethod: 'debit-card';
      }
    | {
          readonly type: 'iframe-view-yaspa';
          readonly url: string;
          readonly yaspaView: 'iframe-view' | 'loading-view';
      }
    | {
          readonly type: 'final-view';
          transactionId?: number;
          readonly paymentProvider: 'realex' | 'paysafe' | 'worldpay';
      }
    | {
          readonly type: 'failure-view';
          readonly failureType: DepositViewType;
          readonly transactionCallback?: TransactionCallbackType;
          readonly longError?: ErrorMessageType[];
      };

export class MultiDepositSteps {
    public step: MultiDepositStepsType;

    public constructor() {
        this.step = {
            type: 'set-amount',
        };
        makeAutoObservable(this);
    }

    public redirectToSetAmount = (): void => {
        this.step = {
            type: 'set-amount',
        };
    };

    public redirectToSelectPaymentMethod = (): void => {
        this.step = {
            type: 'select-payment-method',
        };
    };

    public redirectToRealexLoader = (amount: string): void => {
        this.step = {
            type: 'realex-loader',
            amount,
        };
    };

    public redirectToPaysafeLoader = (amount: string): void => {
        this.step = {
            type: 'paysafe-loader',
            amount,
        };
    };

    public redirectToWorldpayLoader = (amount: string, paymentMethod: 'debit-card'): void => {
        this.step = {
            type: 'worldpay-loader',
            amount,
            paymentMethod,
        };
    };

    public redirectToIframeYaspa = ({ link }: YaspaUrlResponseType): void => {
        this.step = {
            type: 'iframe-view-yaspa',
            url: link,
            yaspaView: 'iframe-view',
        };
    };

    public redirectFromYaspaIframe = (): void => {
        this.step = {
            type: 'iframe-view-yaspa',
            yaspaView: 'loading-view',
            url: '',
        };
    };

    public redirectToFinalView = (
        transactionId: number | undefined,
        paymentProvider: 'realex' | 'paysafe' | 'worldpay' = 'realex'
    ): void => {
        this.step = {
            type: 'final-view',
            transactionId,
            paymentProvider,
        };
    };

    public redirectToFailureView = (
        failureType: DepositViewType,
        transactionCallback?: TransactionCallbackType,
        longError?: ErrorMessageType[]
    ): void => {
        this.step = {
            type: 'failure-view',
            failureType,
            transactionCallback,
            longError,
        };
    };
}
